<template>
  <the-contact />
</template>

<script>
import TheContact from '@/components/TheContact'

export default {
  components: { TheContact },
}
</script>
